
import { createSlice } from '@reduxjs/toolkit';
import {
  postPasswordIntroduction,
  postPasswordValidation,
  postPasswordConfirmation,
  postPasswordChange,
} from './thunk';
import { PasswordState } from './types';

const initialState: PasswordState = {
  loading: false,
  error: null,
  introduction: undefined,
  validationMessage: undefined,
  confirmationMessage: undefined,
  changeMessage: undefined,
};

const passwordSlice = createSlice({
  name: 'password',
  initialState,
  reducers: {
    clearPasswordState: (state) => {
      state.error = null;
      state.introduction = undefined;
      state.validationMessage = undefined;
      state.confirmationMessage = undefined;
      state.changeMessage = undefined;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(postPasswordIntroduction.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(postPasswordIntroduction.fulfilled, (state, action) => {
        state.loading = false;
        state.introduction = action.payload;
      })
      .addCase(postPasswordIntroduction.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || 'Failed to start password reset';
      });

    builder
      .addCase(postPasswordValidation.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(postPasswordValidation.fulfilled, (state, action) => {
        state.loading = false;
        state.validationMessage = action.payload.message || '';
      })
      .addCase(postPasswordValidation.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || 'Password validation failed';
      });

    builder
      .addCase(postPasswordConfirmation.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(postPasswordConfirmation.fulfilled, (state, action) => {
        state.loading = false;
        state.confirmationMessage = action.payload.message || '';
      })
      .addCase(postPasswordConfirmation.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || 'Password confirmation failed';
      });

    builder
      .addCase(postPasswordChange.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(postPasswordChange.fulfilled, (state, action) => {
        state.loading = false;
        state.changeMessage = action.payload.message || '';
      })
      .addCase(postPasswordChange.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || 'Change password failed';
      });
  },
});

export const { clearPasswordState } = passwordSlice.actions;
export default passwordSlice.reducer;
